import { attr, belongsTo } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";

export const reasons = [
  "patient-decision",
  "medic-decision",
  "enrolled-without-consent",
  "patient-death",
  "change-hc",
  "program-stop",
  "diagnostic-in-progress",
  "clinical-study-end",
  "other"
] as const;

export const proIrcReasons = [
  "hemodialysis-permanent",
  "hemodialysis-temporary",
  "peritoneal-dialysis",
  "transplant",
  "palliative-care",
  "lost-followup"
] as const;

//---- Automatically generated, don't update this part ----

export default class PatientDisenrolledJournalEvent extends JournalEvent {
  static override type = "patient-disenrolled-journal-event";

  @attr("string") declare reason: string;

  @attr("date") declare reasonEventOn: Date;

  static override validations(intl: IntlService) {
    return {
      reason: validatePresence({
        presence: true,
        description: intl.t(
          "validations.patient-disenrolled-journal-event.reason"
        )
      }),
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.patient-disenrolled-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée dans le futur. Veuillez modifier la date",
          onOrBefore: dayjs().endOf("day").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----

  @belongsTo("patient", {
    async: false,
    inverse: "patientDisenrolledJournalEvent"
  })
  declare patient: Patient;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "patient-disenrolled-journal-event": PatientDisenrolledJournalEvent;
  }
}
